export default __webpack_public_path__ + "static/media/335.23bbca2b.png";